// before 20-5-2026

// import React, { useEffect, useState, useMemo } from 'react';
// import { Card, Col, Container, Row, ProgressBar } from 'react-bootstrap';
// import { useDispatch, useSelector } from 'react-redux';
// import DataUsageIcon from '@mui/icons-material/DataUsage';

// import { Link, useNavigate } from 'react-router-dom';
// import {
//   AccessibilityNew as AccessibilityNewIcon,
//   TipsAndUpdates as TipsAndUpdatesIcon,
//   Bookmark as BookmarkIcon,
//   AccessTimeFilled as AccessTimeFilledIcon,
//   AccessAlarm as AccessAlarmIcon,
//   TaskAlt as TaskAltIcon,
//   PhonelinkErase as PhonelinkEraseIcon,
//   ThumbUp as ThumbUpIcon,
//   Cancel as CancelIcon,
//   WorkHistory as WorkHistoryIcon,
//   Backspace as BackspaceIcon,
//   ArrowForward as ArrowForwardIcon,
//   ShowChart as ShowChartIcon,
//   TrendingUp as TrendingUpIcon,
//   People as PeopleIcon,
//   Dashboard as DashboardIcon,
//   BarChart as BarChartIcon,
//   Celebration as CelebrationIcon,
// } from '@mui/icons-material';
// import { Doughnut } from 'react-chartjs-2';
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Filler,
// } from 'chart.js';

// import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';
// import { get_sales_dashboard_advanced } from '../Redux/Actions/RoleData_Actions';
// import { Button, useTheme } from '@mui/material';
// import { DashbordPerformanceForAllUsers } from './DashbordPerformanceForAllUsers';

// // Register ChartJS components
// ChartJS.register(
//   ArcElement,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
//   Filler,
// );

// export const SalesDashboard = ({ darkMode = false }) => {
//   const theme = useTheme();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const mode = theme.palette.mode;

//   const [userlogin, setUserLogin] = useState(null);
//   const [loading, setloading] = useState(true);
//   const [performanceData, setPerformanceData] = useState([]);

//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem('user'));
//     if (user) setUserLogin(user);
//   }, []);

//   // تعريف الأيقونات مع ألوان مميزة
//   const stagesIcons = {
//     Fresh: <TipsAndUpdatesIcon sx={{ color: '#118AB2' }} fontSize="large" />,
//     'No Stage': <TipsAndUpdatesIcon sx={{ color: '#118AB2' }} fontSize="large" />,
//     Follow: <BookmarkIcon sx={{ color: '#118AB2' }} fontSize="large" />,
//     'Follow Up': <BookmarkIcon sx={{ color: '#118AB2' }} fontSize="large" />,
//     'Long Follow': <BookmarkIcon sx={{ color: '#118AB2' }} fontSize="large" />,
//     Transfer: <BackspaceIcon sx={{ color: '#118AB2' }} fontSize="large" />,
//     Interested: <ThumbUpIcon sx={{ color: '#118AB2' }} fontSize="large" />,
//     'Not Interested': <BackspaceIcon sx={{ color: '#118AB2' }} fontSize="large" />,
//     Meeting: <AccessTimeFilledIcon sx={{ color: '#118AB2' }} fontSize="large" />,
//     'Following After Meeting': <WorkHistoryIcon sx={{ color: '#118AB2' }} fontSize="large" />,
//     'Follow After Meeting': <WorkHistoryIcon sx={{ color: '#118AB2' }} fontSize="large" />,
//     'Cancel Meeting': <CancelIcon sx={{ color: '#118AB2' }} fontSize="large" />,
//     'Done Deal': <TaskAltIcon sx={{ color: '#118AB2' }} fontSize="large" />,
//     'No Answer': <PhonelinkEraseIcon sx={{ color: '#118AB2' }} fontSize="large" />,
//     'No Answer 1st Call': <AccessAlarmIcon sx={{ color: '#118AB2' }} fontSize="large" />,
//     Cancellation: <CancelIcon sx={{ color: '#118AB2' }} fontSize="large" />,
//     Pending: <AccessibilityNewIcon sx={{ color: '#118AB2' }} fontSize="large" />,
//   };

//   useEffect(() => {
//     dispatch(GetAll_stage_Data());
//   }, [dispatch]);

//   const resAllStages = useSelector((state) => state.Allstages.stage);
//   const stagearray = Array.isArray(resAllStages?.data) ? resAllStages.data : [];

//   // فلترة الـ stages: إخفاء "Fresh" الأصلية فقط
//   const filteredStages = stagearray.filter((stage) => stage.name !== 'Fresh');

//   // دالة لترتيب الـ Stages حسب الترتيب المطلوب
//   const getSortedStages = (stages) => {
//     const order = [
//       'Pending', // أضف Pending في البداية
//       'No Stage', // ضع "No Stage" في البداية
//       'Fresh',
//       'Follow Up',
//       'Meeting',
//       'Follow After Meeting',
//       'Following After Meeting',
//       'Interested',
//       'Not Interested',
//       'No Answer',
//       'No Answer 1st Call',
//       'Done Deal',
//       'Cancellation',
//       'Cancel Meeting',
//       'Transfer',
//       'Long Follow',
//       'Follow',
//     ];

//     return [...stages].sort((a, b) => {
//       const indexA = order.indexOf(a.name);
//       const indexB = order.indexOf(b.name);

//       // إذا كان الاسم في القائمة، استخدم الترتيب المحدد
//       if (indexA !== -1 && indexB !== -1) {
//         return indexA - indexB;
//       }

//       // إذا كان اسم واحد فقط في القائمة، ضعه أولاً
//       if (indexA !== -1) return -1;
//       if (indexB !== -1) return 1;

//       // إذا لم يكن أي منهما في القائمة، ابقيهما كما هما
//       return 0;
//     });
//   };

//   // الحصول على الـ Stages المرتبة
//   const sortedStages = useMemo(() => {
//     return getSortedStages(filteredStages);
//   }, [filteredStages]);

//   const fetchDashboardData = async () => {
//     try {
//       if (userlogin?.data?.email) {
//         await dispatch(get_sales_dashboard_advanced(userlogin.data.email));
//       }
//     } catch (error) {
//       console.error('Error fetching dashboard data:', error);
//     } finally {
//       setloading(false);
//     }
//   };

//   useEffect(() => {
//     if (userlogin) {
//       setloading(true);
//       fetchDashboardData();
//     }
//   }, [userlogin]);

//   // 🔴 التغيير هنا: الوصول إلى البيانات بشكل صحيح
//   const dashboardData = useSelector((state) => state.AllRoleData?.salesdashboard);

//   const handleStageClick = (stageName) => {
//     // إذا كان stageName === "Fresh" (الذي نعرضه)، أرسل "No Stage" للـ API
//     const apiStageName = stageName === 'Fresh' ? 'No Stage' : stageName;
//     localStorage.setItem('stagestorage', apiStageName);
//     navigate(`/AllLeadsForSales?stage=${encodeURIComponent(apiStageName)}`);
//   };

//   // دالة لتعديل اسم الـ stage لعرضه
//   const getDisplayStageName = (stageName) => {
//     if (stageName === 'No Stage') {
//       return 'Fresh';
//     }
//     return stageName;
//   };

//   // 🔴 التغيير هنا: حساب الإحصائيات من بيانات الـ API الجديدة
//   const totalLeads = dashboardData?.data?.summary?.totalLeads || 0;

//   const doneDealsCount = useMemo(() => {
//     if (dashboardData?.data?.stages) {
//       const doneDealStage = dashboardData.data.stages.find(
//         (stage) => stage.stageName === 'Done Deal',
//       );
//       return doneDealStage?.leadsCount || 0;
//     }
//     return 0;
//   }, [dashboardData]);

//   // 🔴 التغيير هنا: حساب عدد الـ Fresh Leads (التي هي No Stage في الواقع)
//   const freshLeadsCount = useMemo(() => {
//     if (dashboardData?.data?.stages) {
//       const noStage = dashboardData.data.stages.find((stage) => stage.stageName === 'No Stage');
//       return noStage?.leadsCount || 0;
//     }
//     return 0;
//   }, [dashboardData]);

//   // 🔴 التغيير هنا: الحصول على عدد الـ leads لكل stage من بيانات الـ API
//   const getLeadsCountForStage = (stageName) => {
//     if (dashboardData?.data?.stages) {
//       const stage = dashboardData.data.stages.find((s) => s.stageName === stageName);
//       return stage?.leadsCount || 0;
//     }
//     return 0;
//   };

//   // 🔴 التغيير هنا: إعداد بيانات الرسم البياني للـ Doughnut مع الـ Stages المرتبة
//   const getStageChartData = useMemo(() => {
//     if (!dashboardData?.data?.stages) {
//       return {
//         labels: [],
//         datasets: [
//           {
//             data: [],
//             backgroundColor: [],
//             borderColor: mode === 'dark' ? '#1a1a2e' : '#ffffff',
//             borderWidth: 2,
//             hoverOffset: 15,
//             hoverBorderWidth: 3,
//           },
//         ],
//       };
//     }

//     const labels = [];
//     const data = [];

//     // استخدام الـ stages من الـ API مرتبة حسب sortedStages
//     sortedStages.forEach((stage) => {
//       if (stage.name === 'Fresh') return;

//       const leadsCount = getLeadsCountForStage(stage.name);
//       if (leadsCount > 0 || stage.name === 'No Stage') {
//         // عرض No Stage حتى لو كان صفر
//         if (stage.name === 'No Stage') {
//           labels.push('Fresh'); // عرض "Fresh" بدلاً من "No Stage"
//         } else {
//           labels.push(stage.name);
//         }
//         data.push(leadsCount);
//       }
//     });

//     // ألوان لكل مرحلة
//     const stageColors = {
//       Fresh: '#118AB2',
//       Pending: '#FF6B35',
//       'No Stage': '#118AB2',
//       Follow: '#118AB2',
//       'Follow Up': '#118AB2',
//       'Long Follow': '#118AB2',
//       Transfer: '#118AB2',
//       Interested: '#118AB2',
//       'Not Interested': '#118AB2',
//       Meeting: '#118AB2',
//       'Following After Meeting': '#118AB2',
//       'Follow After Meeting': '#118AB2',
//       'Cancel Meeting': '#118AB2',
//       'Done Deal': '#118AB2',
//       'No Answer': '#118AB2',
//       'No Answer 1st Call': '#118AB2',
//       Cancellation: '#118AB2',
//     };

//     const backgroundColors = labels.map((label) => {
//       if (label === 'Fresh') return '#118AB2';
//       if (label === 'Pending') return '#FF6B35';
//       return stageColors[label] || '#CCCCCC';
//     });

//     return {
//       labels: labels,
//       datasets: [
//         {
//           data,
//           backgroundColor: backgroundColors,
//           borderColor: mode === 'dark' ? '#1a1a2e' : '#ffffff',
//           borderWidth: 2,
//           hoverOffset: 15,
//           hoverBorderWidth: 3,
//         },
//       ],
//     };
//   }, [dashboardData, sortedStages, mode]);

//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         position: 'right',
//         labels: {
//           color: mode === 'dark' ? '#fff' : '#333',
//           font: {
//             size: 11,
//             family: 'Heebo, sans-serif',
//           },
//           padding: 20,
//           usePointStyle: true,
//           pointStyle: 'circle',
//         },
//       },
//       tooltip: {
//         backgroundColor: mode === 'dark' ? 'rgba(0,0,0,0.8)' : 'rgba(255,255,255,0.9)',
//         titleColor: mode === 'dark' ? '#fff' : '#333',
//         bodyColor: mode === 'dark' ? '#fff' : '#333',
//         borderColor: '#118AB2',
//         borderWidth: 1,
//         callbacks: {
//           label: function (context) {
//             const label = context.label || '';
//             const value = context.raw || 0;
//             const total = context.dataset.data.reduce((a, b) => a + b, 0);
//             const percentage = total > 0 ? Math.round((value / total) * 100) : 0;
//             return `${label}: ${value} leads (${percentage}%)`;
//           },
//         },
//       },
//     },
//     cutout: '60%',
//   };

//   // 🔴 التغيير هنا: تحميل البيانات
//   if (loading) {
//     return (
//       <div
//         style={{
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           minHeight: '100vh',
//           background: mode === 'dark' ? '#1a1a2e' : '#f8f9fa',
//         }}
//       >
//         <div className="text-center">
//           <DashboardIcon sx={{ fontSize: 60, color: '#118AB2', mb: 2 }} />
//           <h4 style={{ color: mode === 'dark' ? '#fff' : '#333' }}>Loading Dashboard...</h4>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div
//       style={{
//         background:
//           mode === 'dark'
//             ? 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%)'
//             : 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
//         minHeight: '100vh',
//         fontFamily: '"Heebo", "Segoe UI", sans-serif',
//       }}
//     >
//       <Container className="py-4 " style={{ marginTop: '80px' }}>
//         {/* ✅ قسم الترحيب مع تأثيرات */}
//         <div className="welcome-section mb-5 text-center">
//           <div className="position-relative">
//             <DashboardIcon
//               sx={{
//                 fontSize: 80,
//                 color: mode === 'dark' ? 'rgba(16, 45, 255, 0.3)' : 'rgba(16, 45, 255, 0.1)',
//                 position: 'absolute',
//                 top: '-20px',
//                 left: '50%',
//                 transform: 'translateX(-50%)',
//                 zIndex: 0,
//               }}
//             />
//             <h2
//               className="fw-bold heebo-bold position-relative"
//               style={{
//                 color: '#102dff',
//                 fontSize: '2.2rem',
//                 textShadow:
//                   mode === 'dark' ? '0 2px 4px rgba(0,0,0,0.3)' : '0 2px 4px rgba(0,0,0,0.1)',
//                 zIndex: 1,
//               }}
//             >
//               Welcome, {userlogin?.data?.name || dashboardData?.data?.salesInfo?.name}!
//             </h2>
//             <p
//               className="mt-2"
//               style={{
//                 fontSize: '1.1rem',
//                 color: mode === 'dark' ? '#aaa' : '#666',
//                 maxWidth: '600px',
//                 margin: '0 auto',
//               }}
//             >
//               Manage your leads and track your sales performance
//             </p>
//           </div>
//         </div>

//         {/* 📊 قسم الإحصائيات السريعة */}
//         <Row className="mb-5">
//           <Col xs={12} className="mb-4">
//             <div className="d-flex align-items-center justify-content-between">
//               {/* الجانب الأيسر: العنوان والأيقونة */}
//               <div className="d-flex align-items-center">
//                 <ShowChartIcon sx={{ color: '#118AB2', mr: 1 }} />
//                 <h4 className="mb-0 fw-bold" style={{ color: mode === 'dark' ? '#fff' : '#333' }}>
//                   Quick Statistics
//                 </h4>
//               </div>

//               {/* الجانب الأيمن: زر CRM Data */}
//               <div>
//                 <Link to="/SalesQuickNumberCRMData" style={{ textDecoration: 'none' }}>
//                   <Button
//                     variant="outlined"
//                     size="small"
//                     startIcon={
//                       <svg
//                         width="16"
//                         height="16"
//                         viewBox="0 0 24 24"
//                         fill="#102dff"
//                         style={{ marginRight: '4px' }}
//                       >
//                         <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" />
//                       </svg>
//                     }
//                     style={{
//                       borderColor: '#102dff',
//                       color: '#102dff',
//                       fontWeight: '500',
//                       textTransform: 'none',
//                     }}
//                   >
//                     CRM Data
//                   </Button>
//                 </Link>
//               </div>
//             </div>
//           </Col>

//           {/* كارت كل الـ Leads */}
//           <Col xs={12} md={6} className="mb-4">
//             <div
//               className="dashboard-card shadow-lg"
//               style={{
//                 background:
//                   mode === 'dark'
//                     ? 'linear-gradient(135deg, #1e1e2e 0%, #2d2d44 100%)'
//                     : 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
//                 border: 'none',
//                 borderRadius: '20px',
//                 overflow: 'hidden',
//                 cursor: 'pointer',
//                 transition: 'all 0.3s ease',
//                 height: '100%',
//                 borderLeft: '5px solid #102dff',
//               }}
//               onClick={() => handleStageClick('')}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.transform = 'translateY(-5px)';
//                 e.currentTarget.style.boxShadow = '0 10px 25px rgba(16, 45, 255, 0.2)';
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.transform = 'translateY(0)';
//                 e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
//               }}
//             >
//               <div className="text-center p-4">
//                 <div className="mb-3">
//                   <div
//                     style={{
//                       width: '70px',
//                       height: '70px',
//                       background: 'linear-gradient(135deg, #102dff 0%, #4a6fff 100%)',
//                       borderRadius: '50%',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       margin: '0 auto',
//                     }}
//                   >
//                     <PeopleIcon sx={{ color: '#fff', fontSize: 35 }} />
//                   </div>
//                 </div>
//                 <h5 className="fw-bold mb-2" style={{ color: mode === 'dark' ? '#ccc' : '#666' }}>
//                   Total Leads
//                 </h5>
//                 <h1 className="fw-bold display-6" style={{ color: '#102dff' }}>
//                   {totalLeads}
//                 </h1>
//                 <small style={{ color: mode === 'dark' ? '#aaa' : '#888' }}>
//                   All leads in your pipeline
//                 </small>
//               </div>
//             </div>
//           </Col>

//           {/* كارت Done Deals */}
//           <Col xs={12} md={6} className="mb-4">
//             <div
//               className="dashboard-card shadow-lg"
//               style={{
//                 background:
//                   mode === 'dark'
//                     ? 'linear-gradient(135deg, #1e1e2e 0%, #2d2d44 100%)'
//                     : 'linear-gradient(135deg, #ffffff 0%, #f0fff7 100%)',
//                 border: 'none',
//                 borderRadius: '20px',
//                 overflow: 'hidden',
//                 cursor: 'pointer',
//                 transition: 'all 0.3s ease',
//                 height: '100%',
//                 borderLeft: '5px solid #06D6A0',
//               }}
//               onClick={() => handleStageClick('Done Deal')}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.transform = 'translateY(-5px)';
//                 e.currentTarget.style.boxShadow = '0 10px 25px rgba(6, 214, 160, 0.2)';
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.transform = 'translateY(0)';
//                 e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
//               }}
//             >
//               <div className="text-center p-4">
//                 <div className="mb-3">
//                   <div
//                     style={{
//                       width: '70px',
//                       height: '70px',
//                       background: 'linear-gradient(135deg, #06D6A0 0%, #4ECDC4 100%)',
//                       borderRadius: '50%',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       margin: '0 auto',
//                     }}
//                   >
//                     <CelebrationIcon sx={{ color: '#fff', fontSize: 35 }} />
//                   </div>
//                 </div>
//                 <h5 className="fw-bold mb-2" style={{ color: mode === 'dark' ? '#ccc' : '#666' }}>
//                   Successful Deals
//                 </h5>
//                 <h1 className="fw-bold display-6" style={{ color: '#06D6A0' }}>
//                   {doneDealsCount}
//                 </h1>
//                 <div className="mt-2">
//                   {totalLeads > 0 && (
//                     <div>
//                       <small style={{ color: mode === 'dark' ? '#aaa' : '#888' }}>
//                         Success Rate: {((doneDealsCount / totalLeads) * 100).toFixed(1)}%
//                       </small>
//                       <ProgressBar
//                         now={(doneDealsCount / totalLeads) * 100}
//                         style={{
//                           height: '8px',
//                           borderRadius: '4px',
//                           marginTop: '5px',
//                           backgroundColor:
//                             mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                         }}
//                         variant="success"
//                       />
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </Col>
//         </Row>

//         {/* 🎯 كروت المراحل المرتبة مع Fresh في البداية */}
//         <Row className="mb-5">
//           <Col xs={12}>
//             <div className="mb-4">
//               <div className="d-flex align-items-center mb-2">
//                 <BookmarkIcon
//                   sx={{
//                     mr: 2,
//                     color: '#118AB2',
//                     fontSize: '2.8rem',
//                     background:
//                       mode === 'dark' ? 'rgba(255, 107, 53, 0.1)' : 'rgba(255, 107, 53, 0.05)',
//                     padding: '10px',
//                     borderRadius: '12px',
//                   }}
//                 />
//                 <div>
//                   <h4
//                     className="fw-bold mb-1"
//                     style={{
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       fontSize: '1.4rem',
//                     }}
//                   >
//                     All Stages
//                   </h4>
//                   <small
//                     style={{
//                       color: mode === 'dark' ? '#aaa' : '#666',
//                       fontSize: '0.9rem',
//                     }}
//                   >
//                     Click any stage to view its leads
//                   </small>
//                 </div>
//               </div>
//             </div>
//           </Col>

//           {/* عرض كروت المراحل من بيانات الـ API */}
//           {sortedStages.map((stage) => {
//             // إذا كانت هذه هي الـ stage الأصلية "Fresh"، تخطاها
//             if (stage.name === 'Fresh') return null;

//             const leadsCount = getLeadsCountForStage(stage.name);
//             const displayName = getDisplayStageName(stage.name);
//             const percentage = totalLeads > 0 ? ((leadsCount / totalLeads) * 100).toFixed(1) : 0;

//             // لون Fresh Stage (#3d3d5c) لجميع الكروت
//             const freshColor = {
//               primary: '#118AB2',
//               light: mode === 'dark' ? 'rgba(255, 107, 53, 0.2)' : 'rgba(255, 107, 53, 0.1)',
//               gradient: 'linear-gradient(135deg, #118AB2 0%, #118AB2 100%)',
//               lightGradient:
//                 mode === 'dark'
//                   ? 'linear-gradient(135deg, rgba(255, 107, 53, 0.2) 0%, rgba(255, 142, 83, 0.2) 100%)'
//                   : 'linear-gradient(135deg, rgba(255, 107, 53, 0.08) 0%, rgba(255, 142, 83, 0.08) 100%)',
//             };

//             // استخدم لون مختلف لـ Pending
//             const cardColor =
//               stage.name === 'Pending'
//                 ? {
//                     primary: '#FF6B35',
//                     light: mode === 'dark' ? 'rgba(255, 107, 53, 0.2)' : 'rgba(255, 107, 53, 0.1)',
//                     gradient: 'linear-gradient(135deg, #FF6B35 0%, #FF8E53 100%)',
//                     lightGradient:
//                       mode === 'dark'
//                         ? 'linear-gradient(135deg, rgba(255, 107, 53, 0.2) 0%, rgba(255, 142, 83, 0.2) 100%)'
//                         : 'linear-gradient(135deg, rgba(255, 107, 53, 0.08) 0%, rgba(255, 142, 83, 0.08) 100%)',
//                   }
//                 : freshColor;

//             return (
//               <Col key={stage._id} xs={12} sm={6} md={4} lg={3} className="mb-4">
//                 <div
//                   className="stage-card"
//                   onClick={() => handleStageClick(displayName)}
//                   style={{
//                     background: mode === 'dark' ? '#1e1e2e' : '#ffffff',
//                     border:
//                       mode === 'dark'
//                         ? `1px solid ${cardColor.primary}40`
//                         : `1px solid ${cardColor.primary}20`,
//                     borderRadius: '16px',
//                     cursor: 'pointer',
//                     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//                     height: '100%',
//                     overflow: 'hidden',
//                     position: 'relative',
//                     boxShadow:
//                       mode === 'dark'
//                         ? '0 4px 12px rgba(0, 0, 0, 0.2)'
//                         : '0 4px 12px rgba(0, 0, 0, 0.05)',
//                   }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.transform = 'translateY(-4px) scale(1.02)';
//                     e.currentTarget.style.boxShadow =
//                       mode === 'dark'
//                         ? `0 12px 24px rgba(0, 0, 0, 0.3), 0 0 0 1px ${cardColor.primary}40`
//                         : `0 12px 24px rgba(0, 0, 0, 0.08), 0 0 0 1px ${cardColor.primary}20`;
//                     e.currentTarget.style.borderColor = cardColor.primary + '60';
//                     e.currentTarget.style.background =
//                       mode === 'dark' ? '#222233' : cardColor.lightGradient;
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.transform = 'translateY(0) scale(1)';
//                     e.currentTarget.style.boxShadow =
//                       mode === 'dark'
//                         ? '0 4px 12px rgba(0, 0, 0, 0.2)'
//                         : '0 4px 12px rgba(0, 0, 0, 0.05)';
//                     e.currentTarget.style.borderColor =
//                       mode === 'dark' ? `${cardColor.primary}40` : `${cardColor.primary}20`;
//                     e.currentTarget.style.background = mode === 'dark' ? '#1e1e2e' : '#ffffff';
//                   }}
//                 >
//                   {/* شريط اللون العلوي */}
//                   <div
//                     style={{
//                       height: '4px',
//                       background: cardColor.gradient,
//                       width: '100%',
//                     }}
//                   />

//                   <div className="p-4">
//                     {/* رأس الكارت */}
//                     <div className="d-flex align-items-center justify-content-between mb-3">
//                       <div
//                         style={{
//                           width: '44px',
//                           height: '44px',
//                           background: cardColor.light,
//                           borderRadius: '12px',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           border: `1px solid ${cardColor.primary}30`,
//                         }}
//                       >
//                         {React.cloneElement(stagesIcons[stage.name] || <AccessibilityNewIcon />, {
//                           sx: {
//                             color: cardColor.primary,
//                             fontSize: 22,
//                             transition: 'transform 0.3s ease',
//                           },
//                         })}
//                       </div>

//                       <div
//                         style={{
//                           background: cardColor.light,
//                           padding: '4px 12px',
//                           borderRadius: '20px',
//                           border: `1px solid ${cardColor.primary}30`,
//                         }}
//                       >
//                         <span
//                           style={{
//                             color: cardColor.primary,
//                             fontSize: '0.8rem',
//                             fontWeight: '600',
//                           }}
//                         >
//                           {percentage}%
//                         </span>
//                       </div>
//                     </div>

//                     {/* اسم المرحلة */}
//                     <h6
//                       className="fw-bold mb-2"
//                       style={{
//                         color: mode === 'dark' ? '#fff' : '#333',
//                         fontSize: '1rem',
//                         lineHeight: '1.4',
//                       }}
//                     >
//                       {displayName}
//                     </h6>

//                     {/* عدد الـ Leads */}
//                     <div className="mb-3">
//                       <div
//                         style={{
//                           fontSize: '2rem',
//                           fontWeight: '700',
//                           color: cardColor.primary,
//                           lineHeight: '1',
//                           marginBottom: '4px',
//                         }}
//                       >
//                         {leadsCount}
//                       </div>
//                       <small
//                         style={{
//                           color: mode === 'dark' ? '#aaa' : '#666',
//                           fontSize: '0.8rem',
//                         }}
//                       >
//                         leads
//                       </small>
//                     </div>

//                     {/* شريط التقدم */}
//                     <div>
//                       <div className="d-flex justify-content-between mb-1">
//                         <small
//                           style={{
//                             color: mode === 'dark' ? '#888' : '#777',
//                             fontSize: '0.75rem',
//                             fontWeight: '500',
//                           }}
//                         >
//                           Progress
//                         </small>
//                         <small
//                           style={{
//                             color: cardColor.primary,
//                             fontSize: '0.75rem',
//                             fontWeight: '600',
//                           }}
//                         >
//                           {leadsCount} of {totalLeads}
//                         </small>
//                       </div>
//                       <div
//                         style={{
//                           height: '6px',
//                           background:
//                             mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)',
//                           borderRadius: '3px',
//                           overflow: 'hidden',
//                           position: 'relative',
//                         }}
//                       >
//                         <div
//                           style={{
//                             width: `${percentage}%`,
//                             height: '100%',
//                             background: cardColor.gradient,
//                             borderRadius: '3px',
//                             transition: 'width 0.5s ease',
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </div>

//                   {/* زر التفاصيل */}
//                   <div className="px-4 pb-3">
//                     <div
//                       style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         padding: '8px',
//                         background: cardColor.light,
//                         borderRadius: '8px',
//                         border: `1px solid ${cardColor.primary}30`,
//                         cursor: 'pointer',
//                         transition: 'all 0.2s ease',
//                       }}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleStageClick(displayName);
//                       }}
//                       onMouseEnter={(e) => {
//                         e.currentTarget.style.background = cardColor.primary;
//                         e.currentTarget.style.borderColor = cardColor.primary;
//                         e.currentTarget.querySelector('span').style.color = '#fff';
//                         e.currentTarget.querySelector('svg').style.color = '#fff';
//                       }}
//                       onMouseLeave={(e) => {
//                         e.currentTarget.style.background = cardColor.light;
//                         e.currentTarget.style.borderColor = `${cardColor.primary}30`;
//                         e.currentTarget.querySelector('span').style.color = cardColor.primary;
//                         e.currentTarget.querySelector('svg').style.color = cardColor.primary;
//                       }}
//                     >
//                       <span
//                         style={{
//                           color: cardColor.primary,
//                           fontSize: '0.8rem',
//                           fontWeight: '600',
//                           marginRight: '6px',
//                           transition: 'color 0.2s ease',
//                         }}
//                       >
//                         View Details
//                       </span>
//                       <ArrowForwardIcon
//                         sx={{
//                           color: cardColor.primary,
//                           fontSize: 16,
//                           transition: 'color 0.2s ease',
//                         }}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </Col>
//             );
//           })}
//         </Row>

//         {/* 📊 الرسم البياني للـ Stages */}
//         <Row className="mb-5">
//           <Col xs={12} lg={6} className="mb-4">
//             <div
//               className="shadow-lg"
//               style={{
//                 background:
//                   mode === 'dark'
//                     ? 'linear-gradient(135deg, #1e1e2e 0%, #2d2d44 100%)'
//                     : 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
//                 border: 'none',
//                 borderRadius: '20px',
//                 overflow: 'hidden',
//                 height: '100%',
//               }}
//             >
//               <div className="p-4">
//                 <div className="mb-4">
//                   <h5 className="fw-bold mb-1" style={{ color: mode === 'dark' ? '#fff' : '#333' }}>
//                     <BarChartIcon sx={{ mr: 1, color: '#118AB2' }} />
//                     Leads Distribution by Stage
//                   </h5>
//                   <small style={{ color: mode === 'dark' ? '#aaa' : '#666' }}>
//                     Visual breakdown of leads across all stages
//                   </small>
//                 </div>
//                 <div style={{ height: '350px', position: 'relative' }}>
//                   <Doughnut data={getStageChartData} options={chartOptions} />
//                 </div>
//               </div>
//             </div>
//           </Col>

//           {/* 🎯 قائمة المراحل المرتبة مع Fresh في البداية */}
//           <Col xs={12} lg={6} className="mb-4">
//             <div
//               className="shadow-lg"
//               style={{
//                 background:
//                   mode === 'dark'
//                     ? 'linear-gradient(135deg, #1e1e2e 0%, #2d2d44 100%)'
//                     : 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
//                 border: 'none',
//                 borderRadius: '20px',
//                 overflow: 'hidden',
//                 height: '100%',
//               }}
//             >
//               <div className="p-4">
//                 <div className="mb-4">
//                   <h5 className="fw-bold mb-1" style={{ color: mode === 'dark' ? '#fff' : '#333' }}>
//                     <BookmarkIcon sx={{ mr: 1, color: '#118AB2' }} />
//                     Stages Overview
//                   </h5>
//                   <small style={{ color: mode === 'dark' ? '#aaa' : '#666' }}>
//                     Click any stage to view its leads
//                   </small>
//                 </div>

//                 <div
//                   style={{
//                     maxHeight: '350px',
//                     overflowY: 'auto',
//                     paddingRight: '10px',
//                   }}
//                 >
//                   {/* عرض جميع الـ stages المرتبة */}
//                   {sortedStages.map((stage) => {
//                     // إذا كانت هذه هي الـ stage الأصلية "Fresh"، تخطاها
//                     if (stage.name === 'Fresh') return null;

//                     const leadsCount = getLeadsCountForStage(stage.name);
//                     const displayName = getDisplayStageName(stage.name);
//                     const percentage =
//                       totalLeads > 0 ? ((leadsCount / totalLeads) * 100).toFixed(1) : 0;

//                     // تحديد اللون بناءً على المرحلة
//                     const stageColor = stage.name === 'Pending' ? '#FF6B35' : '#118AB2';

//                     return (
//                       <div
//                         key={stage._id}
//                         className="mb-3 stage-list-card"
//                         onClick={() => handleStageClick(displayName)}
//                         style={{
//                           background: mode === 'dark' ? '#2d2d44' : '#ffffff',
//                           border: '1px solid',
//                           borderColor: mode === 'dark' ? stageColor + '40' : stageColor + '20',
//                           borderRadius: '12px',
//                           cursor: 'pointer',
//                           transition: 'all 0.3s ease',
//                         }}
//                         onMouseEnter={(e) => {
//                           e.currentTarget.style.transform = 'translateX(5px)';
//                           e.currentTarget.style.borderColor = stageColor;
//                         }}
//                         onMouseLeave={(e) => {
//                           e.currentTarget.style.transform = 'translateX(0)';
//                           e.currentTarget.style.borderColor =
//                             mode === 'dark' ? stageColor + '40' : stageColor + '20';
//                         }}
//                       >
//                         <div className="p-3">
//                           <div className="d-flex align-items-center justify-content-between">
//                             <div className="d-flex align-items-center" style={{ flex: 1 }}>
//                               <div className="me-3">
//                                 {React.cloneElement(
//                                   stagesIcons[stage.name] || <AccessibilityNewIcon />,
//                                   {
//                                     sx: {
//                                       color: stageColor,
//                                       fontSize: 24,
//                                     },
//                                   },
//                                 )}
//                               </div>
//                               <div style={{ flex: 1 }}>
//                                 <h6
//                                   className="fw-bold mb-1"
//                                   style={{
//                                     color: mode === 'dark' ? '#fff' : '#333',
//                                     fontSize: '0.9rem',
//                                   }}
//                                 >
//                                   {displayName}
//                                 </h6>
//                                 <div className="d-flex align-items-center">
//                                   <div style={{ flex: 1, marginRight: '10px' }}>
//                                     <ProgressBar
//                                       now={percentage}
//                                       style={{
//                                         height: '6px',
//                                         borderRadius: '3px',
//                                         backgroundColor:
//                                           mode === 'dark'
//                                             ? 'rgba(255,255,255,0.1)'
//                                             : 'rgba(0,0,0,0.1)',
//                                       }}
//                                       variant="primary"
//                                     />
//                                   </div>
//                                   <span
//                                     style={{
//                                       fontSize: '0.8rem',
//                                       color: stageColor,
//                                       minWidth: '60px',
//                                       textAlign: 'right',
//                                       fontWeight: '600',
//                                     }}
//                                   >
//                                     {percentage}%
//                                   </span>
//                                 </div>
//                               </div>
//                             </div>

//                             <div className="text-end" style={{ minWidth: '80px' }}>
//                               <div
//                                 style={{
//                                   fontSize: '1.2rem',
//                                   fontWeight: 'bold',
//                                   color: stageColor,
//                                 }}
//                               >
//                                 {leadsCount}
//                               </div>
//                               <small
//                                 style={{
//                                   fontSize: '0.75rem',
//                                   color: mode === 'dark' ? '#aaa' : '#888',
//                                 }}
//                               >
//                                 leads
//                               </small>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>
//             </div>
//           </Col>
//         </Row>

//         {/* 📊 قسم الأداء */}
//         <div
//           className="mt-5 pt-4 border-top"
//           style={{
//             borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//           }}
//         >
//           <DashbordPerformanceForAllUsers darkMode={mode === 'dark'} />
//         </div>
//       </Container>

//       {/* تخصيص ProgressBar */}
//       <style>
//         {`
//           .progress-bar {
//             background-color: #118AB2 !important;
//           }
          
//           .progress-bar-success {
//             background-color: #06D6A0 !important;
//           }
          
//           .stage-card:hover {
//             transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//           }
          
//           .heebo-bold {
//             font-family: 'Heebo', sans-serif;
//             font-weight: 700 !important;
//           }
          
//           .dashboard-card {
//             border-radius: 20px !important;
//             box-shadow: 0 4px 15px rgba(0,0,0,0.1);
//           }
          
//           /* تخصيص Scrollbar */
//           ::-webkit-scrollbar {
//             width: 6px;
//           }
          
//           ::-webkit-scrollbar-track {
//             background: ${mode === 'dark' ? '#1a1a2e' : '#f1f1f1'};
//             border-radius: 10px;
//           }
          
//           ::-webkit-scrollbar-thumb {
//             background: #118AB2;
//             border-radius: 10px;
//           }
          
//           ::-webkit-scrollbar-thumb:hover {
//             background: #118AB2;
//           }
          
//           /* Animation for cards */
//           @keyframes fadeInUp {
//             from {
//               opacity: 0;
//               transform: translateY(20px);
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0);
//             }
//           }
          
//           .stage-list-card {
//             animation: fadeInUp 0.3s ease-out;
//           }
//         `}
//       </style>
//     </div>
//   );
// };























// 20-5-2026
import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material';
import {
  AccessibilityNew as AccessibilityNewIcon,
  TipsAndUpdates as TipsAndUpdatesIcon,
  Bookmark as BookmarkIcon,
  AccessTimeFilled as AccessTimeFilledIcon,
  AccessAlarm as AccessAlarmIcon,
  TaskAlt as TaskAltIcon,
  PhonelinkErase as PhonelinkEraseIcon,
  ThumbUp as ThumbUpIcon,
  Cancel as CancelIcon,
  WorkHistory as WorkHistoryIcon,
  Backspace as BackspaceIcon,
  ShowChart as ShowChartIcon,
  BarChart as BarChartIcon,
} from '@mui/icons-material';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS, ArcElement, Tooltip, Legend,
  CategoryScale, LinearScale, PointElement, LineElement, Title, Filler,
} from 'chart.js';

import { GetAll_stage_Data }              from '../Redux/Actions/Stage_Action';
import { get_sales_dashboard_advanced }   from '../Redux/Actions/RoleData_Actions';
import { DashbordPerformanceForAllUsers } from './DashbordPerformanceForAllUsers';
import { useSidebarWidth }                from '../Utility/useSidebarWidth';
import { useMediaQuery }                  from '@mui/material';

ChartJS.register(ArcElement, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

// ─── Tokens ───────────────────────────────────────────────────────────────────
const C = {
  bg:          '#F7F8FC',
  white:       '#FFFFFF',
  border:      '#E8EAF0',
  accent:      '#0D47A1',
  accentDark:  '#0D47A1',
  accentSoft:  'rgba(26,62,207,0.07)',
  text:        '#1C2340',
  textMuted:   '#7B829A',
  success:     '#12B76A',
  successSoft: 'rgba(18,183,106,0.08)',
  warning:     '#F79009',
  danger:      '#F04438',
  shadow:      '0 1px 3px rgba(16,24,40,0.08)',
  shadowMd:    '0 4px 16px rgba(16,24,40,0.10)',
};

const SIDEBAR_COLLAPSED = 64;

// ─── Stage icons ──────────────────────────────────────────────────────────────
const STAGE_ICONS = {
  Fresh:                     <TipsAndUpdatesIcon />,
  'No Stage':                <TipsAndUpdatesIcon />,
  'Follow Up':               <BookmarkIcon />,
  Follow:                    <BookmarkIcon />,
  'Long Follow':             <BookmarkIcon />,
  Transfer:                  <BackspaceIcon />,
  Interested:                <ThumbUpIcon />,
  'Not Interested':          <BackspaceIcon />,
  Meeting:                   <AccessTimeFilledIcon />,
  'Following After Meeting': <WorkHistoryIcon />,
  'Follow After Meeting':    <WorkHistoryIcon />,
  'Cancel Meeting':          <CancelIcon />,
  'Done Deal':               <TaskAltIcon />,
  'No Answer':               <PhonelinkEraseIcon />,
  'No Answer 1st Call':      <AccessAlarmIcon />,
  Cancellation:              <CancelIcon />,
  Pending:                   <AccessibilityNewIcon />,
};

const stageColor = (name) => name === 'Pending' ? '#F79009' : C.accent;

// ─── helper: استخرج الـ user object من أي structure ─────────────────────────
// الـ response بيكون: { success, data: { _id, name, email, role, ... }, token }
// localStorage بيحفظ الـ response كله
const extractUser = (stored) => {
  if (!stored) return null;
  // لو عنده data.email مباشرةً (الـ user object نفسه)
  if (stored.email) return stored;
  // لو عنده data.data.email (الـ response object)
  if (stored.data?.email) return stored.data;
  return null;
};

// ─── Stat card ────────────────────────────────────────────────────────────────
const StatCard = ({ label, value, sub, highlight, onClick }) => (
  <div
    onClick={onClick}
    style={{
      background: highlight ? C.accent : C.white,
      border: `1px solid ${highlight ? C.accent : C.border}`,
      borderRadius: 12, padding: '20px 24px',
      minWidth: 160, height: 120,
      boxShadow: highlight ? '0 4px 16px rgba(26,62,207,0.25)' : C.shadow,
      display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
      cursor: onClick ? 'pointer' : 'default', flexShrink: 0,
      transition: 'transform 0.15s, box-shadow 0.15s',
    }}
    onMouseEnter={e => { if (onClick) { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(26,62,207,0.18)'; } }}
    onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = highlight ? '0 4px 16px rgba(26,62,207,0.25)' : C.shadow; }}
  >
    <span style={{ fontSize: 11, fontWeight: 500, color: highlight ? 'rgba(255,255,255,0.75)' : C.textMuted, letterSpacing: '0.06em', textTransform: 'uppercase', fontFamily: "'DM Sans',sans-serif" }}>{label}</span>
    <span style={{ fontSize: 26, fontWeight: 700, color: highlight ? '#fff' : C.text, fontFamily: "'DM Sans',sans-serif", lineHeight: 1.2 }}>{value ?? '—'}</span>
    {sub && <span style={{ fontSize: 11, color: highlight ? 'rgba(255,255,255,0.6)' : C.textMuted, fontFamily: "'DM Sans',sans-serif" }}>{sub}</span>}
    {highlight && <div style={{ height: 3, width: 40, background: C.warning, borderRadius: 2 }} />}
  </div>
);

// ─── Stage card ───────────────────────────────────────────────────────────────
const StageCard = ({ stage, displayName, leadsCount, totalLeads, onClick }) => {
  const color      = stageColor(stage.name);
  const pct        = totalLeads > 0 ? ((leadsCount / totalLeads) * 100).toFixed(1) : 0;
  const icon       = STAGE_ICONS[stage.name] || <AccessibilityNewIcon />;
  const isDoneDeal = stage.name === 'Done Deal';
  const isPending  = stage.name === 'Pending';

  return (
    <div onClick={onClick} style={{
      background: isDoneDeal ? '#F79009' : isPending ? '#FFF8EC' : C.white,
      border: `1px solid ${isDoneDeal ? '#F79009' : isPending ? '#F7900940' : C.border}`,
      borderRadius: 10, padding: '12px 16px', cursor: 'pointer',
      transition: 'transform 0.15s, box-shadow 0.15s, border-color 0.15s',
      boxShadow: isDoneDeal ? '0 4px 16px rgba(247,144,9,0.30)' : C.shadow,
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      gap: 10, minHeight: 70,
    }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = isDoneDeal ? '0 8px 24px rgba(247,144,9,0.40)' : C.shadowMd; if (!isDoneDeal && !isPending) e.currentTarget.style.borderColor = color; }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = isDoneDeal ? '0 4px 16px rgba(247,144,9,0.30)' : C.shadow; e.currentTarget.style.borderColor = isDoneDeal ? '#F79009' : isPending ? '#F7900940' : C.border; }}
    >
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 10, fontWeight: 600, letterSpacing: '0.07em', textTransform: 'uppercase', color: isDoneDeal ? 'rgba(255,255,255,0.85)' : C.textMuted, fontFamily: "'DM Sans',sans-serif", marginBottom: 4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {displayName}
        </div>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 5 }}>
          <span style={{ fontSize: 24, fontWeight: 800, lineHeight: 1, color: isDoneDeal ? '#fff' : isPending ? '#F79009' : color, fontFamily: "'DM Sans',sans-serif" }}>{leadsCount}</span>
          <span style={{ fontSize: 11, fontWeight: 500, color: isDoneDeal ? 'rgba(255,255,255,0.7)' : C.textMuted, fontFamily: "'DM Sans',sans-serif" }}>{pct}%</span>
        </div>
      </div>
      <div style={{ flexShrink: 0, opacity: isDoneDeal ? 0.9 : 0.55, display: 'flex', alignItems: 'center' }}>
        {React.cloneElement(icon, { sx: { color: isDoneDeal ? '#fff' : color, fontSize: 22 } })}
      </div>
    </div>
  );
};

// ─── Stage row ────────────────────────────────────────────────────────────────
const StageRow = ({ stage, displayName, leadsCount, totalLeads, onClick }) => {
  const color = stageColor(stage.name);
  const pct   = totalLeads > 0 ? ((leadsCount / totalLeads) * 100).toFixed(1) : 0;
  const icon  = STAGE_ICONS[stage.name] || <AccessibilityNewIcon />;

  return (
    <div onClick={onClick} style={{
      display: 'flex', alignItems: 'center', gap: 12,
      padding: '12px 16px', background: C.white, border: `1px solid ${C.border}`,
      borderRadius: 10, cursor: 'pointer', marginBottom: 8,
      transition: 'transform 0.15s, border-color 0.15s',
    }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateX(4px)'; e.currentTarget.style.borderColor = color; }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'translateX(0)'; e.currentTarget.style.borderColor = C.border; }}
    >
      <div style={{ width: 34, height: 34, borderRadius: 8, background: color + '12', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        {React.cloneElement(icon, { sx: { color, fontSize: 18 } })}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: C.text, fontFamily: "'DM Sans',sans-serif", marginBottom: 5 }}>{displayName}</div>
        <div style={{ height: 4, background: C.border, borderRadius: 2, overflow: 'hidden' }}>
          <div style={{ width: `${pct}%`, height: '100%', background: color, borderRadius: 2 }} />
        </div>
      </div>
      <div style={{ textAlign: 'right', flexShrink: 0 }}>
        <div style={{ fontSize: 16, fontWeight: 700, color, fontFamily: "'DM Sans',sans-serif" }}>{leadsCount}</div>
        <div style={{ fontSize: 11, color: C.textMuted, fontFamily: "'DM Sans',sans-serif" }}>{pct}%</div>
      </div>
    </div>
  );
};

// ─── Main ─────────────────────────────────────────────────────────────────────
export const SalesDashboard = () => {
  const theme    = useTheme();
  const mode     = theme.palette.mode;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sidebarW = useSidebarWidth();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [userlogin, setUserlogin] = useState(null);
  const [loading,   setLoading]   = useState(true);

  // ── جيب الـ user من localStorage مع دعم الـ structure القديم والجديد ──────
  useEffect(() => {
    const raw = localStorage.getItem('user');
    if (!raw) return;
    try {
      const parsed = JSON.parse(raw);
      const user   = extractUser(parsed);
      console.log('👤 stored raw:', parsed);
      console.log('👤 extracted user:', user);
      setUserlogin(user);
    } catch (e) {
      console.error('❌ Failed to parse user from localStorage:', e);
    }
  }, []);

  useEffect(() => { dispatch(GetAll_stage_Data()); }, [dispatch]);

  const resAllStages  = useSelector(s => s.Allstages.stage);
  const dashboardData = useSelector(s => s.AllRoleData?.salesdashboard);

  const stagearray     = Array.isArray(resAllStages?.data) ? resAllStages.data : [];
  const filteredStages = stagearray.filter(s => s.name !== 'Fresh');

  const STAGE_ORDER = ['Pending','No Stage','Fresh','Follow Up','Meeting','Follow After Meeting','Following After Meeting','Interested','Not Interested','No Answer','No Answer 1st Call','Done Deal','Cancellation','Cancel Meeting','Transfer','Long Follow','Follow'];

  const sortedStages = useMemo(() => [...filteredStages].sort((a, b) => {
    const ia = STAGE_ORDER.indexOf(a.name), ib = STAGE_ORDER.indexOf(b.name);
    if (ia !== -1 && ib !== -1) return ia - ib;
    if (ia !== -1) return -1; if (ib !== -1) return 1; return 0;
  }), [filteredStages]);

  // ── dispatch بالـ email بعد ما الـ user يتحمل ────────────────────────────
  useEffect(() => {
    if (!userlogin) return;

    // الـ email ممكن يكون في أي مكان حسب الـ structure
    const email = userlogin?.email || userlogin?.data?.email;
    console.log('📧 Dispatching dashboard with email:', email);

    if (email) {
      dispatch(get_sales_dashboard_advanced(email))
        .finally(() => setLoading(false));
    } else {
      console.error('❌ No email found — check localStorage structure');
      setLoading(false);
    }
  }, [userlogin]);

  const totalLeads = dashboardData?.data?.summary?.totalLeads || 0;

  const doneDealsCount = useMemo(() =>
    dashboardData?.data?.stages?.find(s => s.stageName === 'Done Deal')?.leadsCount || 0,
    [dashboardData]
  );

  const convRate = totalLeads > 0 ? ((doneDealsCount / totalLeads) * 100).toFixed(1) : 0;

  const getCount       = (name) => dashboardData?.data?.stages?.find(s => s.stageName === name)?.leadsCount || 0;
  const getDisplayName = (name) => name === 'No Stage' ? 'Fresh' : name;

  const handleStageClick = (displayName) => {
    const api = displayName === 'Fresh' ? 'No Stage' : displayName;
    localStorage.setItem('stagestorage', api);
    navigate(`/AllLeadsForSales?stage=${encodeURIComponent(api)}`);
  };

  const chartData = useMemo(() => {
    const labels = [], data = [], colors = [];
    sortedStages.forEach(s => {
      if (s.name === 'Fresh') return;
      const count = getCount(s.name);
      if (count > 0 || s.name === 'No Stage') {
        labels.push(getDisplayName(s.name));
        data.push(count);
        colors.push(stageColor(s.name));
      }
    });
    return {
      labels,
      datasets: [{ data, backgroundColor: colors, borderColor: mode === 'dark' ? '#1a1a2e' : '#fff', borderWidth: 2, hoverOffset: 12 }],
    };
  }, [dashboardData, sortedStages, mode]);

  const chartOptions = {
    responsive: true, maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
        labels: { color: mode === 'dark' ? '#fff' : C.text, font: { size: 11, family: "'DM Sans',sans-serif" }, padding: 16, usePointStyle: true, pointStyle: 'circle' },
      },
      tooltip: {
        backgroundColor: C.white, titleColor: C.text, bodyColor: C.textMuted,
        borderColor: C.border, borderWidth: 1,
        callbacks: { label: ctx => { const t = ctx.dataset.data.reduce((a,b)=>a+b,0); return `${ctx.label}: ${ctx.raw} leads (${t>0?((ctx.raw/t)*100).toFixed(1):0}%)`; } },
      },
    },
    cutout: '62%',
  };

  // ── Loading ───────────────────────────────────────────────────────────────
  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:C.bg }}>
      <div style={{ textAlign:'center' }}>
        <div style={{ width:48, height:48, borderRadius:'50%', border:`3px solid ${C.accentSoft}`, borderTop:`3px solid ${C.accent}`, animation:'spin 0.8s linear infinite', margin:'0 auto 16px' }} />
        <div style={{ fontSize:14, color:C.textMuted, fontFamily:"'DM Sans',sans-serif" }}>Loading Dashboard...</div>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );

  // ── اسم الـ user للعرض ────────────────────────────────────────────────────
  const displayName = userlogin?.name || userlogin?.data?.name || 'Sales';

  return (
    <div style={{ marginLeft: isMobile ? SIDEBAR_COLLAPSED : sidebarW, marginTop:64, minHeight:'calc(100vh - 64px)', background:C.bg, transition:'margin-left 0.25s cubic-bezier(0.4,0,0.2,1)', fontFamily:"'DM Sans',sans-serif" }}>
      <div style={{ padding: isMobile ? '16px' : '28px 28px 48px' }}>

        {/* Header */}
        <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', flexWrap:'wrap', gap:16, marginBottom:28 }}>
          <div>
            <div style={{ fontSize: isMobile ? 28 : 36, fontWeight:800, color:C.text, lineHeight:1.15, letterSpacing:'-0.02em', fontFamily:"'DM Sans',sans-serif" }}>
              Sales<br />Dashboard
            </div>
            <div style={{ fontSize:13.5, color:C.textMuted, marginTop:8, fontFamily:"'DM Sans',sans-serif" }}>
              Welcome back, <strong style={{ color:C.text }}>{displayName}</strong> — track your pipeline and performance.
            </div>
          </div>

          <div style={{ display:'flex', gap:12, flexWrap:'wrap', alignItems:'stretch' }}>
            <StatCard label="Total Leads"  value={totalLeads}            onClick={() => handleStageClick('')} />
            <StatCard label="Done Deals"   value={doneDealsCount}        onClick={() => handleStageClick('Done Deal')} />
            <StatCard label="Fresh Leads"  value={getCount('No Stage')} />
            <StatCard label="Conv. Rate"   value={`${convRate}%`}        highlight />
          </div>
        </div>

        {/* Toolbar */}
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20, flexWrap:'wrap', gap:8 }}>
          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            <ShowChartIcon sx={{ color:C.accent, fontSize:18 }} />
            <span style={{ fontSize:16, fontWeight:700, color:C.text, fontFamily:"'DM Sans',sans-serif" }}>All Stages</span>
            <span style={{ fontSize:12, color:C.textMuted, fontFamily:"'DM Sans',sans-serif" }}>— click any card to view its leads</span>
          </div>
          <Link to="/SalesQuickNumberCRMData" style={{ textDecoration:'none' }}>
            <button style={{ display:'flex', alignItems:'center', gap:6, padding:'7px 14px', borderRadius:8, border:`1px solid ${C.border}`, background:C.white, color:C.text, fontSize:13, fontWeight:600, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", transition:'all 0.15s' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor=C.accent; e.currentTarget.style.color=C.accent; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor=C.border; e.currentTarget.style.color=C.text; }}>
              <BarChartIcon sx={{ fontSize:16 }} />
              CRM Data
            </button>
          </Link>
        </div>

        {/* Stage cards grid */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(160px, 1fr))', gap:12, marginBottom:28 }}>
          {sortedStages.map(stage => {
            if (stage.name === 'Fresh') return null;
            return (
              <StageCard
                key={stage._id}
                stage={stage}
                displayName={getDisplayName(stage.name)}
                leadsCount={getCount(stage.name)}
                totalLeads={totalLeads}
                onClick={() => handleStageClick(getDisplayName(stage.name))}
              />
            );
          })}
        </div>

        {/* Chart + List */}
        <div style={{ display:'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap:16, marginBottom:28 }}>

          <div style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:12, boxShadow:C.shadow, overflow:'hidden' }}>
            <div style={{ padding:'20px 22px 16px', borderBottom:`1px solid ${C.border}` }}>
              <div style={{ fontSize:15, fontWeight:700, color:C.text, fontFamily:"'DM Sans',sans-serif" }}>
                <BarChartIcon sx={{ fontSize:17, color:C.accent, verticalAlign:'middle', mr:0.5 }} />
                Leads Distribution
              </div>
              <div style={{ fontSize:12, color:C.textMuted, fontFamily:"'DM Sans',sans-serif", marginTop:3 }}>Visual breakdown across all stages</div>
            </div>
            <div style={{ padding:'20px 22px', height:320 }}>
              <Doughnut data={chartData} options={chartOptions} />
            </div>
          </div>

          <div style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:12, boxShadow:C.shadow, overflow:'hidden' }}>
            <div style={{ padding:'20px 22px 16px', borderBottom:`1px solid ${C.border}` }}>
              <div style={{ fontSize:15, fontWeight:700, color:C.text, fontFamily:"'DM Sans',sans-serif" }}>
                <BookmarkIcon sx={{ fontSize:17, color:C.accent, verticalAlign:'middle', mr:0.5 }} />
                Stages Overview
              </div>
              <div style={{ fontSize:12, color:C.textMuted, fontFamily:"'DM Sans',sans-serif", marginTop:3 }}>Click any stage to view its leads</div>
            </div>
            <div style={{ padding:'16px 22px', maxHeight:320, overflowY:'auto' }}>
              {sortedStages.map(stage => {
                if (stage.name === 'Fresh') return null;
                return (
                  <StageRow
                    key={stage._id}
                    stage={stage}
                    displayName={getDisplayName(stage.name)}
                    leadsCount={getCount(stage.name)}
                    totalLeads={totalLeads}
                    onClick={() => handleStageClick(getDisplayName(stage.name))}
                  />
                );
              })}
            </div>
          </div>
        </div>

        {/* Performance */}
        <div style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:12, boxShadow:C.shadow, overflow:'hidden' }}>
          <div style={{ padding:'20px 22px 16px', borderBottom:`1px solid ${C.border}` }}>
            <div style={{ fontSize:15, fontWeight:700, color:C.text, fontFamily:"'DM Sans',sans-serif" }}>Performance Analytics</div>
            <div style={{ fontSize:12, color:C.textMuted, fontFamily:"'DM Sans',sans-serif", marginTop:3 }}>Your activity and conversion metrics</div>
          </div>
          <div style={{ padding:'20px 22px' }}>
            <DashbordPerformanceForAllUsers darkMode={mode === 'dark'} />
          </div>
        </div>

      </div>
    </div>
  );
};

